import { assetConstants, chainConstants, type ChainflipAsset } from '@chainflip/utils/chainflip';
import { intervalToDurationWords } from '@chainflip/utils/date';
import { isNotNullish } from '@chainflip/utils/guard';
import { SkeletonLine } from '@/shared/components/atoms/LoadingSkeleton';
import Button from '@/shared/components/flip-ui-kit/Button';
import { TokenLogo } from '@/shared/components/logo/TokenLogo';
import TimeBoost from '@/shared/icons/flip-ui-kit/large/TimeBoost';
import { chainflipAssetMap } from '@/shared/utils/env';
import TokenAmount from '@/shared/utils/TokenAmount';

interface BoostOptInModalProps {
  asset: ChainflipAsset;
  availableAmount?: bigint;
  maxBoostFeePips?: number;
  onAccept: () => void;
  onDecline: () => void;
}
export const BoostOptInModalContent = ({
  asset,
  availableAmount,
  maxBoostFeePips,
  onAccept,
  onDecline,
}: BoostOptInModalProps) => {
  const averageBoostDuration = intervalToDurationWords({
    start: 0,
    end: (chainConstants[assetConstants[asset].chain].blockTimeSeconds / 2) * 1000,
  });

  return (
    <div className="flex w-[487px] flex-col gap-6 rounded-md border border-cf-gray-4 bg-cf-gray-3 p-6 font-aeonikMedium">
      <div className="text-24 text-white">Boost available!</div>
      <div className="flex flex-col gap-1 text-14 text-cf-light-2">
        <div>
          Pay up to a{' '}
          <span className="text-cf-light-3">
            {maxBoostFeePips ? (
              `${(maxBoostFeePips / 100).toFixed(2)}%`
            ) : (
              <SkeletonLine count={1} width={30} inline />
            )}{' '}
            fee
          </span>{' '}
          and decrease your deposit time down to
        </div>
        <div className="flex items-center gap-1.5">
          <TimeBoost className="text-cf-pink-1" />
          <div className="flex items-baseline gap-1.5">
            <span className="text-24 text-cf-white">{averageBoostDuration}</span>
            <span>(on average)</span>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-1 text-14 text-cf-light-2">
        <div>Currently available in the pool</div>
        <div className="flex items-center gap-x-2 text-24 text-white">
          <TokenLogo token={asset} size="medium" />
          {isNotNullish(availableAmount) ? (
            TokenAmount.fromAsset(availableAmount, asset).toFormatted('numeral')
          ) : (
            <SkeletonLine count={1} width={60} />
          )}{' '}
          {chainflipAssetMap[asset].symbol}
        </div>
      </div>

      <div className="flex justify-end gap-4">
        <Button type="secondary-standard" onClick={onDecline}>
          Skip
        </Button>
        <Button onClick={onAccept}>Enable Boost</Button>
      </div>
    </div>
  );
};
